import type { ApiError } from '@common/api/graphql/apolloClient';
import type { GetLoginUserResponse } from '../../../../common/api/graphql/getLoginUserGql';
import { getLoginUser } from '../../../../common/api/graphql/getLoginUserGql';
import {
  getLoginUserFailure,
  getLoginUserStart,
  getLoginUserSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

const getLoginUserSuccessThunk =
  (response: GetLoginUserResponse): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(getLoginUserSuccess(response.data!));
    return Promise.resolve();
  };

export const getLoginUserFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(getLoginUserFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const getLoginUserThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    dispatch(getLoginUserStart());
    return getLoginUser()
      .then(response => dispatch(getLoginUserSuccessThunk(response)))
      .catch(error => dispatch(getLoginUserFailureThunk(error)));
  };
